export default {
	"1630b6b6ad76b424e048fdb1a557976b": "蘋果支付",
	"eb0d5a7799b129f06512c166d0268563": "谷歌支付",
	"e738a4caf17b913853b4a71a6bc9ef47": "參數錯誤!",
	"397eb0a681632c476010ab12553d0647": "簽約中...",
	"a6d6b6694979b1225ca56e57a8ca4b80": "支付中...",
	"7ec39eb7726bd374fca9faf82c2dc7ac": "您確定要放棄支付嗎？",
	"f382c25c78cd507886f788fc5ac67d02": "支付結果確認中",
	"73fd929b5f73dd4b0671ab94ab824273": "請勿重複支付或離開此頁面哦"
}
